import React, { useState, useEffect, useWindowFocus} from "react";
// eslint-disable-next-line

import NavBar from "./Navbar";

import "./Messages.css";
import { use } from "react";
import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import * as flatted from "flatted";

import { getFunctions, httpsCallable } from 'firebase/functions';

import { ConsoleView, isMobile } from "react-device-detect";

// const socket = io.connect('http://localhost:3000');
import axios from "axios";

import Students from "./Mapofstudents/Mapofstudents";

// eslint-disable-next-line


import { auth, firebase, firebaseConfig } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import { initializeApp } from 'firebase/app';

import {
  admin,
  getAuth,
  signInWithEmailAndPassword,
  initializeAuth, getReactNativePersistence,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
  connectAuthEmulator,
  setPersistence,
} from "@firebase/auth";


import ReactNativeAsyncStorage from '@react-native-async-storage/async-storage';


// Removed firebase-functions as it is not compatible with React Native


const app = initializeApp(firebaseConfig);

// const auth2 = initializeAuth(app, {
//   persistence: setPersistence(ReactNativeAsyncStorage)
// });







// eslint-disable-next-line


const MAX = 10;

function Getclasses({ route, navigation }) {
  // eslint-disable-line no-unused-vars

  const { only2studentid, studentid, classid, language, role } = useParams();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [donotshow, setDonotshow] = useState();
  const [someoneisloggedin, setSomeoneisloggedin] = useState(false);
  const [id2, setId2] = useState();
  const [school2, setSchool2] = useState();
  const [town2, setTown2] = useState();
  const [state2, setState2] = useState();
  const [schoolid2, setSchoolid2] = useState();

  const [role2, setRole2] = useState();
  const [school, setSchool] = useState();
  const [todayspasses, setTodayspasses] = useState();

  const [lasttwomonths, setLasttwomonths] = useState([]);
  const [lasttwomonths2, setLasttwomonths2] = useState();

  const [selectedclass, setSelectedclass] = useState();

  const [updatesent, setUpdatesent] = useState();

  const [activename, setActivename] = useState("Active Passes");

  const [lastupdate, setLastupdate] = useState(0);
  const [selectedpass, setSelectedpass] = useState();
  const [idselected, setIdselected] = useState();
  const [currentstudentid, setCurrentsstudentid] = useState();
  const [arrayofstudentpasses, setArrayofstudentpassees] = useState();

  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  const [studentname, setStudentname] = useState("");
  const [numberofdaysago, setNumberofdaysago] = useState();

  const [newdatestring, setNewdatestring] = useState();
  const [path, setPath] = useState();

  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  const [popupData, setPopupData] = useState(null);

  const auth = getAuth();

  const location = useLocation();

  const [newWindow, setNewWindow] = useState(null);

  const [urlValue, setUrlValue] = useState("");
  const [data, setData] = useState(null);

  const [stringToSend, setStringToSend] = useState("");

  const [response, setResponse] = useState("");

  const [courses2, setCourses2] = useState();
  const [courses23, setCourses23] = useState();
  const [data3, setData3] = useState(null);

  const [email, setEmail] = useState('');

  const [courses3, setCourses3] = useState([]);
  const [idToken, setIdToken] = useState(null);
  const [isSignedIn, setIsSignedIn] = useState(false);

    const [sections, setSections] = useState();



  return (
    <div className="App22">
      <NavBar
        donotshow={donotshow}
        role={role}
        sections={sections}
        setSelectedclass={setSelectedclass}
        activename={activename}
      />
      <div className="App">
        {/* //frontend Youtube Downolader */}

        {/* end */}

        <header className="App-header">
        <div className="App-header22 privacy-policy-text">
<br></br><br></br>

            <h1>Privacy Policy for Fastclasspass</h1>
            <br></br>
<p>Last updated: June 21, 2025</p>
<br></br>
<p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You. We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.</p>

<br></br>  <br></br>
<h1>Interpretation and Definitions</h1>
<br></br>
<h2>Interpretation</h2>
<br></br>
<p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
<br></br>  <br></br>
<h2>Definitions</h2>
<br></br>
<p>For the purposes of this Privacy Policy:</p>
<ul>
<br></br>
<li>
<p><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</p>
</li>
<br></br>
<li>
<p><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where &quot;control&quot; means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</p>
</li>
<br></br>
<li>
<p><strong>Application</strong> means the software program provided by the Company downloaded by You on any electronic device, named Fastclasspass</p>
</li>
<br></br>
<li>
<p><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Fastclasspass.</p>
</li>
<br></br>
<li>
<p><strong>Country</strong> refers to: Massachusetts,  United States</p>
</li>
<br></br>
<li>
<p><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</p>
</li>
<br></br>
<li>
<p><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</p>
</li>
<br></br>
<li>
<p><strong>Service</strong> refers to the Application.</p>
</li>
<br></br>
<li>
<br></br>
<p><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</p>
</li>
<br></br>
<li>
<p><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</p>
</li>
<br></br>
<li>
<p><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p>
</li>
<br></br>
</ul>
<br></br>  <br></br>
<h1>Collecting and Using Your Personal Data</h1>
<br></br>
<h2>Types of Data Collected</h2>
<br></br>
<h3>Personal Data</h3>
<br></br>
<p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
<br></br>
<ul>
<li>
<p>Email address</p>
</li>
<br></br>
<li>
<p>Usage Data</p>
</li>
</ul>
<br></br>  <br></br>
<h3>Usage Data</h3>
<br></br>
<p>Usage Data is collected automatically when using the Service.</p>
<br></br>
<p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
<br></br>
<p>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p>
<br></br>
<p>We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.</p>
<br></br>  <br></br>
<h2>Use of Your Personal Data</h2>
<br></br>
<p>The Company may use Personal Data for the following purposes:</p>
<br></br>
<ul>
<li>
<p><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</p>
</li>
<br></br>
<li>
<p><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.</p>
</li>
<br></br>
<li>
<p><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</p>
</li>
<br></br>
<li>
<p><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</p>
</li>
<br></br>
<li>
<p><strong>To provide You</strong> with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.</p>
</li>
<br></br>
<li>
<p><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</p>
</li>
<br></br>
<li>
<p><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</p>
</li>
<br></br>
<li>
<p><strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</p>
</li>
</ul>
<br></br>  <br></br>
<p>We may share Your personal information in the following situations:</p>
<br></br>
<ul>
<li><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service,  to contact You.</li>
<br></br>
<li><strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</li>
<br></br>
<li><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
<br></br>
<li><strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
<br></br>
<li><strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
<br></br>
<li><strong>With Your consent</strong>: We may disclose Your personal information for any other purpose with Your consent.</li>
</ul>
<br></br>  <br></br>
<h2>Retention of Your Personal Data</h2>
<br></br>
<p>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
<br></br>
<p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.</p>
<br></br>  <br></br>
<h2>Transfer of Your Personal Data</h2>
<br></br>
<p>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.</p>  <br></br>
<p>Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.</p>
<br></br>
<p>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.</p>  <br></br>  <br></br>
<h2>Disclosure of Your Personal Data</h2>
<br></br>
<h3>Business Transactions</h3>
<br></br>
<p>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</p>  <br></br>  <br></br>
<h3>Law enforcement</h3>  <br></br>
<p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p>  <br></br>  <br></br>
<h3>Other legal requirements</h3>
<br></br>
<p>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p>
<ul>  <br></br> 
<li>Comply with a legal obligation</li>  <br></br>
<li>Protect and defend the rights or property of the Company</li>  <br></br>
<li>Prevent or investigate possible wrongdoing in connection with the Service</li>  <br></br>
<li>Protect the personal safety of Users of the Service or the public</li>
<br></br>
<li>Protect against legal liability</li>
</ul>
<br></br>  <br></br>
<h2>Security of Your Personal Data</h2>  <br></br>  <br></br>
<p>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</p>  <br></br>  <br></br>
<h1>Children's Privacy</h1>  <br></br>
<p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</p>  <br></br>
<p>If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</p>  <br></br><br></br>
<h1>Links to Other Websites</h1>  <br></br>  <br></br>
<p>Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</p>  <br></br>
<p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>  <br></br>  <br></br>
<h1>Changes to this Privacy Policy</h1>  <br></br>
<p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</p>  <br></br>
<p>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the &quot;Last updated&quot; date at the top of this Privacy Policy.</p>  <br></br>
<p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>  <br></br>  <br></br>
<h1>Contact Us</h1>  <br></br>
<p>If you have any questions about this Privacy Policy, You can contact us:</p>  <br></br>  
<p>
By email: mattkrebsemail@gmail.com</p>
        </div>  <br></br>  <br></br>
        

        </header>
      </div>
    </div>
  );
}

export default Getclasses;
